<template>
  <div :class="{
    page: true,
    'page-devices': true,
    content: true,
    'page--overlayed': overlayVisible,
  }">
    <h1 class="page__title">{{ t('devices.menuTitle') }}</h1>

    <LinkButton
        form="scanForNewDevices"
        :text="t('devices.scan')"
        @click.native="startScanning"
        :disable-on-submit="true"
        :submit="true"
        :icon-right="'Arrow'"
        :disabled="isCommunityless" />

    <InfoBox :text="t('global.communitylessDevicesHint')" v-if="isCommunityless" />

    <DevicesList :devices="wifiSwitches" />
    <ChooseProviderPopup v-if="chooseProviderPopup.isVisible" context="pageDevices" />
  </div>
</template>

<script>
  import LinkButton from '@/components/LinkButton.vue'
  import DevicesList from '@/components/devices/DevicesList.vue'
  import ChooseProviderPopup from '@/components/popups/ChooseProviderPopup.vue'
  import { useStrings } from '@/composables/useStrings.ts'
  import { computed } from 'vue'
  import { DEVICE_TYPE_MYSTROM_WIFI_SWITCH } from '@/constants.ts'
  import { usePopupOverlay } from '@/composables/usePopupOverlay.ts'
  import { useSpecificPopup } from '@/composables/useSpecificPopup.ts'
  import { useDeviceStore } from '@/stores/useDeviceStore'
  import { useAccountStore } from '@/stores/useAccountStore'
  import InfoBox from '@/components/InfoBox.vue'

  export default {
    name: 'page-devices',
    components: {
      LinkButton,
      DevicesList,
      ChooseProviderPopup,
      InfoBox
    },
    setup() {
      const deviceStore = useDeviceStore()
      const { t } = useStrings()
      const accountStore = useAccountStore()
      const { overlayVisible } = usePopupOverlay('pageDevices')
      const chooseProviderPopup = useSpecificPopup("chooseProvider")
      const isCommunityless = computed(() => accountStore.properties.isCommunityless);

      const wifiSwitches = computed(() => deviceStore.devicesList.filter(
        (d) => d.deviceType === DEVICE_TYPE_MYSTROM_WIFI_SWITCH
      ))

      return {
        t,
        chooseProviderPopup,
        overlayVisible,
        wifiSwitches,
        startScanning: () => deviceStore.scanForNewDevices(DEVICE_TYPE_MYSTROM_WIFI_SWITCH),
        isCommunityless
      }
    },
  }
</script>

<style lang="scss">
  .page-devices {
    max-width: $content-page-width;
    // What is this needed for?
    // This messes up the choose provider popup's width.
    //position: relative;
  }

  .notice {
    padding-left: $spacer10;
    border-left: 3px solid $community;
  }
</style>
